export const ProductBundleRowType = {
    BUNDLE_ITEM: 'BUNDLE_ITEM',
    BUNDLE_DISCOUNT: 'BUNDLE_DISCOUNT',
};
